/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/710/interface/api
 */
import { message } from 'ant-design-vue'
import { ref, watch } from 'vue'
import {
  v1_hot_tag_index_post,
  v1_hot_tag_upOnShelf_post,
  v1_hot_tag_create_post,
  v1_hot_tag_delete_post,
  v1_hot_tag_update_post,
  v1_hot_tag_upOnShelfAll_post,
  v1_hot_tag_setOnShelf_post,
  v1_hot_tag_setOffShelf_post,
  v1_hot_tag_autoTrackMenu_post,
  v1_hot_tag_getAutoMenuList_post
} from 'server/modules/4285' // 查询标签

export const v1_hot_tag_index_post_ = async function(state) {
  const { success, data, retInfo } = await v1_hot_tag_index_post({
    type: state.type,
    systemId: state.systemId,
    status: state.status
  })

  if (success) {
    // 非自动上报的
    state.dataSource = data.list.filter(item => {
      return item.isAuto !== 1
    })
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 创建标签

export const v1_hot_tag_create_post_ = async function(formState, state) {
  const { tagName, tagURL, systemName, systemId, type } = formState
  const { success, data, retInfo } = await v1_hot_tag_create_post({
    tagName,
    tagURL,
    systemName,
    systemId,
    type
  })
  if (success) {
    Object.assign(formState, {
      tagName: null,
      tagURL: null,
      systemName: null,
      systemId: null,
      type: 2
    })
    state.visible = false
    message.success('创建成功')
    v1_hot_tag_index_post_(state)
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 删除标签

export const v1_hot_tag_delete_post_ = async function(id, state) {
  const { success, data, retInfo } = await v1_hot_tag_delete_post({
    id
  })
  if (success) {
    v1_hot_tag_index_post_(state)
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 更新记录

export const v1_hot_tag_update_post_ = async function(formState, state) {
  const { tagName, tagURL, systemName, systemId, type, id } = formState
  const { success, data, retInfo } = await v1_hot_tag_update_post({
    tagName,
    tagURL,
    systemName,
    systemId,
    type,
    id
  })
  if (success) {
    Object.assign(formState, {
      tagName: null,
      tagURL: null,
      systemName: null,
      systemId: null,
      type: 2,
      id: null
    })
    state.visible = false
    message.success('更新成功')
    v1_hot_tag_index_post_(state)
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 查询全部上架的标签

export const v1_hot_tag_upOnShelfAll_post_ = function() {
  const quickEntryList = ref([])
  let navications = []
  const isOpenTag = ref(false) // 获取本地存储的快捷入口
  const vuex = JSON.parse(localStorage.getItem('vuex'))
  const dingTalkUserId = vuex.user.userInfo.dingTalkUserId

  const getHotTags = async () => {
    const result = await Promise.all([
      v1_hot_tag_upOnShelfAll_post({}),
      v1_hot_tag_getAutoMenuList_post({
        userId: dingTalkUserId
      })
    ])
    navications = result[1].data.list || []
    if (result[0].data.list.length === 0) {
      quickEntryList.value = navications
    } else {
      mergeTags(result[0].data.list)
    }
    console.log(111, result)
    // const {
    //   success,
    //   data: { list },
    //   retInfo
    // } = await v1_hot_tag_upOnShelfAll_post({})

    // if (success) {
    //   // if (list.length === 0) {
    //   //   quickEntryList.value = navications
    //   // } else {
    //   //   mergeTags(list)
    //   // }
    //   mergeTags(list)
    // } else {
    //   message.error(retInfo)
    // }
  } // 合并标签

  const mergeTags = tags => {
    let locals = []
    quickEntryList.value = []
    const max = 16 // 标签数

    const tagLen = tags.length // 本地保存的数目

    const localCount = navications.length || 0 // 总数

    const totals = localCount + tagLen

    if (totals > max) {
      locals = navications.slice(totals - max, localCount)
    } else {
      locals = navications
    }

    tags.map(item => {
      const { tagName, tagURL, systemId, systemName, id, type } = item
      const index = locals.findIndex(_ => {
        return _.tagName === item.tagName && +_.systemId === item.systemId
      })

      if (index > -1) {
        locals[index].type = type
      } else {
        locals.push({
          tagName,
          tagURL,
          systemId,
          systemName,
          id,
          type
        })
      }
    })
    quickEntryList.value = locals
  }

  // getNavicate()
  getHotTags()
  watch(
    () => isOpenTag.value,
    val => {
      // getNavicate()
      getHotTags()
    }
  )
  return {
    quickEntryList,
    isOpenTag
  }
} // 设置上架

export const v1_hot_tag_setOnShelf_post_ = async function(id, state) {
  const { success, data, retInfo } = await v1_hot_tag_setOnShelf_post({
    id
  })
  if (success) {
    message.success('上架成功')
    v1_hot_tag_index_post_(state)
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 设置下架

export const v1_hot_tag_setOffShelf_post_ = async function(id, state) {
  const { success, data, retInfo } = await v1_hot_tag_setOffShelf_post({
    id
  })
  if (success) {
    message.success('下架成功')
    v1_hot_tag_index_post_(state)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询全部上架的标签
export const v1_hot_tag_upOnShelf_post_ = async function(params) {
  const { success, data, retInfo } = await v1_hot_tag_upOnShelf_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 自动上报菜单
export const v1_hot_tag_autoTrackMenu_post_ = async function(params) {
  const { success, data, retInfo } = await v1_hot_tag_autoTrackMenu_post(params)
  if (success) {
    console.log(data)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询当前用户下所有自动上报的数据，且按照数量从大到小排列
export const v1_hot_tag_getAutoMenuList_post_ = async function(params) {
  const vuex = JSON.parse(localStorage.getItem('vuex'))
  const dingTalkUserId = vuex.user.userInfo.dingTalkUserId
  const { success, data, retInfo } = await v1_hot_tag_getAutoMenuList_post({
    userId: dingTalkUserId
  })
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
